import React from "react";
import {makeAppTopMod} from "src/utilities/utilityFunctions";
import {isLoggedIn} from "src/utilities/utilityFunctions";
import {colorsThemes} from "src/datamodels/kidsLife";
import {loggedInMenu,notLoggedInMenu,endMenu} from "src/datamodels/tdp";
import {appSettingModel} from "src/datamodels/foundation";
import CaretDown from "src/components/icons/CaretDown";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

const assembleMenu = () => {
    return ([]).concat(endMenu).concat(isLoggedIn() ? loggedInMenu : notLoggedInMenu);
};

function hideMenu(){
    var element = document.querySelector("#basic-navbar-nav")
    element.classList.remove("show");
}

const renderMenu = (props) => {
    return (
        assembleMenu().map((item,idx)=>{
            if(item.hasOwnProperty("click")){
                return (
                    <Nav.Link className={"current_page_item menu-item-simple-parent menu-item-depth-0 " + colorsThemes[idx+2]} key={idx} id={item.id} onClick={()=>{item.click();hideMenu()}}>{item.label}</Nav.Link>
                )
            }
            return (
                <Nav.Link className={"current_page_item menu-item-simple-parent menu-item-depth-0 " + colorsThemes[idx+2]} key={idx} id={item.id} onClick={()=>{makeAppTopMod(item.module);hideMenu()}}>{item.label}</Nav.Link>
                )
        })
    )
};

const handleMenuSelection = (whicMod) => {
    makeAppTopMod(whicMod);
    // document.getElementById("about-us-submenu").style.display = "none";
};
/*
@media only screen and (min-width: 480px) and (max-width: 767px){
    .dt-menu-toggle {
        display: block;
    }
}
*/
//current_page_item menu-item-simple-parent menu-item-depth-0
const KidsLifeTopMenu = (props) => {
    return (
        <Navbar bg="none" expand="lg" id="lsfkjgs" style={{paddingTop:0}}>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <Nav.Link onClick={()=>makeAppTopMod(isLoggedIn() ? appSettingModel().defaultLoggedInModule : appSettingModel().defaultModule)}>Home</Nav.Link>
              <NavDropdown title="What Is TDP?" id="basic-nav-dropdown">
                <NavDropdown.Item onClick={()=>handleMenuSelection("components/TDP/content/TDPAboutUs")}>What Is TDP?</NavDropdown.Item>
                <NavDropdown.Item onClick={()=>handleMenuSelection("components/TDP/content/TDPHowWork")}>How Does It Work?</NavDropdown.Item>
                <NavDropdown.Item onClick={()=>handleMenuSelection("components/TDP/content/TDPBackstory")}>Back Story</NavDropdown.Item>
              </NavDropdown>
              {renderMenu(props)}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
    )
    // return (
    //     <nav id="main-menu">
    //         <div className="dt-menu-toggle" id="dt-menu-toggle" style={{display:'none'}}>Menu<span className="dt-menu-toggle-icon"></span></div>
    //         <ul id="menu-main-menu" className="menu">
    //             <li className={"current_page_item menu-item-simple-parent menu-item-depth-0 " + colorsThemes[0]} key={1} id="homeButton">
    //                 <a onClick={()=>makeAppTopMod(isLoggedIn() ? appSettingModel().defaultLoggedInModule : appSettingModel().defaultModule)}> Home</a>
    //             </li>
    //             <li className={"current_page_item menu-item-simple-parent menu-item-depth-0 " + colorsThemes[1]} key={2}>
    //                 <a>What Is TDP? <CaretDown/></a>
    //                 <ul className="sub-menu sub-menu-tn" id="about-us-submenu" style={{display:"none"}}>
    //                     <li> <a onClick={()=>handleMenuSelection("components/TDP/content/TDPAboutUs")}> What Is TDP?</a> </li>
    //                     <li> <a onClick={()=>handleMenuSelection("components/TDP/content/TDPHowWork")}> How Does It Work?</a> </li>
    //                     <li> <a onClick={()=>handleMenuSelection("components/TDP/content/TDPBackstory")}> Back Story </a> </li>
    //                 </ul>
    //             </li>
    //             {renderMenu(props)}
    //         </ul>
    //     </nav>
    // )
};

export default KidsLifeTopMenu
